import React from "react";
import {
  IMediaInputProps,
  MediaInput,
  Message,
} from "@zendeskgarden/react-forms";
import PasswordVisibilityIcon from "../password-visibility-icon";

interface PasswordInputProps
  extends Omit<IMediaInputProps, "type" | "end" | "validation"> {
  visible: boolean;
  onToggle: (visible: boolean) => void;
  invalid?: boolean;
  errorMessage?: string;
}

const PasswordInput = ({
  visible,
  onToggle,
  invalid,
  errorMessage,
  ...props
}: PasswordInputProps) => (
  <>
    <MediaInput
      {...props}
      validation={invalid ? "error" : undefined}
      type={visible ? "text" : "password"}
      end={<PasswordVisibilityIcon visible={visible} onToggle={onToggle} />}
    />
    {invalid && errorMessage && (
      <Message validation="error">{errorMessage}</Message>
    )}
  </>
);

export default PasswordInput;
